/*
 * Public API Surface of local-storage
 */

export { SERIALIZATION_ERROR, SerializationError } from "./lib/databases/exceptions";
export { LocalDatabase } from "./lib/databases/local-database";
export {
  provideIndexedDBDataBaseName, provideIndexedDBDataBaseVersion,
  provideIndexedDBStoreName, provideLocalStoragePrefix
} from "./lib/providers";
export { StorageModule } from "./lib/storage.module";
export { VALIDATION_ERROR, ValidationError } from "./lib/storages/exceptions";
export { LocalStorage } from "./lib/storages/local-storage.service";
export { StorageMap } from "./lib/storages/storage-map.service";
export { StorageConfig } from "./lib/tokens";
export { JSONSchema, JSONSchemaArray, JSONSchemaArrayOf, JSONSchemaBoolean, JSONSchemaInteger, JSONSchemaNumber, JSONSchemaObject, JSONSchemaString } from "./lib/validation/json-schema";
export { JSONValidator } from "./lib/validation/json-validator";
